import Hero from './components/Hero';
import CategoryNav from './components/CategoryNav';
import MissionSection from './components/MissionSection';
import Newsletter from './components/Newsletter';
import Testimonials from './components/Testimonials';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-slate-900">
      <Hero />
      <CategoryNav />
      <MissionSection />
      <Testimonials />
      <Newsletter />
      <Footer />
    </div>
  );
}